const HistoryRecords = {
  list: [],
  push: (key, callback) => {
    HistoryRecords.list.push({
      key,
      callback
    });
    window.history.pushState(key, null, `#${key}`);
  },
  pop: () => {
    window.history.back();
  },
  init: () => {
    window.addEventListener('popstate', (e) => {
      if (e) {
        console.log(`in pop`, e.state);
        const { state } = e;
        let record = HistoryRecords.list.pop();
        // console.log(`history pop`, record);
        if (record && record.callback) {
          record.callback();
        }
      }
    });
  }
};

HistoryRecords.init();

export const pushHistory = HistoryRecords.push;
export const popHistory = HistoryRecords.pop;

export default HistoryRecords;
